module.exports = __webpack_public_path__ + "img/2024-09-19b_3.b583b328.jpg";